// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__1YRrF","control":"ProfileForm_control__1nodr","action":"ProfileForm_action__3B-M3"};